import { ReactNode } from "react";
import { Box, BoxProps, Typography } from "@mui/material";

import { styled, SxProps } from "@mui/material/styles";

const Section = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.vars.palette.divider}`,
  borderRadius: theme.spacing(2),
  backgroundColor: theme.vars.palette.background.paper,
}));

const Content = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  display: "flex",
  gap: theme.spacing(2),
  flexDirection: "column",
  alignItems: "flex-start",
}));

const Header = styled(Box)(({ theme }) => ({
  borderTopRightRadius: theme.spacing(2),
  borderTopLeftRadius: theme.spacing(2),
  borderBottom: `1px solid ${theme.vars.palette.divider}`,
  width: "100%",
  padding: theme.spacing(2),
  paddingBottom: theme.spacing(1.5),
}));

type SectionCardProps = {
  title: string;
  sx?: SxProps;
  children?: ReactNode;
} & BoxProps;

export const SectionCard = ({
  title,
  children,
  ...boxProps
}: SectionCardProps) => {
  return (
    <Section {...boxProps}>
      <Header>
        <Typography textTransform={"uppercase"} fontWeight={500}>
          {title}
        </Typography>
      </Header>
      <Content>{children}</Content>
    </Section>
  );
};
